import { hash } from 'ohash'
import { computed } from 'vue'
import { useAsyncData, useRoute, useRuntimeConfig } from 'nuxt/app'

interface AttachmentSource {
  web_attachments?: Array<{ web_content_id: number }>
}

export function useAttachmentItems(
  item: () => AttachmentSource,
  { lazy = false }: { lazy?: boolean } = {}
) {
  const route = useRoute()
  const version = useRuntimeConfig().public.content.integrity
  const query = computed(() => JSON.stringify({
    path: route.path,
    contentId: item().web_attachments?.[0]?.web_content_id,
  }))
  const key = computed(() => `${version}-${hash(query.value)}`)

  return useAsyncData<Record<string, any>[]>(
    () => `attachments-${key.value}`,
    () => item().web_attachments?.length
      ? $fetch(`/api/attachments/${key.value}`, { query: { query: query.value } })
      : Promise.resolve([]),
    { default: () => [], lazy }
  )
}
